import React, { useState } from 'react';
import AuthLanding  from './components/auth/AuthLanding';
import ScanPage     from './components/ScanPage';
import ResultsPage  from './components/ResultsPage';
import HomePage     from './components/home/HomePage';
import SettingsPage from './components/settings/SettingsPage';
import ProfilePage  from './components/profile/ProfilePage';
import NavBar       from './components/NavBar';
import './App.scss';

export default function App() {
  /* ---------- auth gate ---------- */
  const [isLoggedIn, setLoggedIn] = useState(false);   // ← start unauth

  /* ---------- tab state ---------- */
  const [activeTab, setActiveTab] = useState('home');

  /* ---------- route resolver ---------- */
  let Content;

  if (!isLoggedIn) {
    Content = <AuthLanding onAuthSuccess={() => setLoggedIn(true)} />;
  } else {
    if (activeTab === 'home')     Content = <HomePage />;
    else if (activeTab === 'results')  Content = <ResultsPage />;
    else if (activeTab === 'scan')     Content = <ScanPage />;
    else if (activeTab === 'settings') Content = <SettingsPage />;
    else if (activeTab === 'profile')  Content = <ProfilePage />;
  }

  return (
    <div className="app-container">
      <div className="mobile-wrapper">
        <div className="content-area">{Content}</div>

        {/* show nav only when logged in */}
        {isLoggedIn && (
          <NavBar active={activeTab} onChange={setActiveTab} />
        )}
      </div>
    </div>
  );
}
